import PageTitle from '../components/CommonComps/Titles/PageTitle';
import ShowAllNotifications from '../components/NotificationsComps/ShowAllNotifications';

const Notifications = () => {
  // rendering notifications page component here
  return (
    <>
      <PageTitle title='Notifications' />

      <ShowAllNotifications />
    </>
  );
};

export default Notifications;
